import React, { useMemo, useState } from 'react';

import SignInSSO from 'components/shared/SignInSSO';

import session from 'domains/session';
import photoModule from 'domains/photos';

import { renderModal } from 'utils/modal_util';
import { useAppDispatch, useAppSelector } from 'utils/hooks';

import CollectionsMenu from './CollectionsMenu';
import SaveUncollectedModal from './SaveUncollectedModal';
import SingleCollectionManager from './SingleCollectionManager/SingleCollectionManager';
import { SelectCollectionModal } from './AllCollectionsManager/SelectCollectionModal';

import type { CollectionName } from 'domains/photos';

function ImageCollectionsController() {
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(session.selectors.isLoggedIn);
  const collections = useAppSelector(photoModule.selectors.allNamedCollections);
  const uncollected = useAppSelector(photoModule.selectors.uncollectedCollection);
  // const displayCollection = useAppSelector(selectDisplayCollectionName);
  const activeCollection = useAppSelector(photoModule.selectors.activeCollection);

  const [showUncollectedDialog, setShowUncollectedDialog] = useState(false);
  const [showCollectionsManagerDialog, setShowCollectionsManagerDialog] = useState(false);
  const [displayCollection, setDisplayCollection] = useState<CollectionName>('');

  const showSingleCollectionManager = useMemo(
    () => displayCollection || displayCollection === null, // aka "Uncollected"
    [displayCollection]
  );

  function handleSaveUncollected() {
    setShowUncollectedDialog(true);
  }

  function handleCancelSaveUncollected() {
    setShowUncollectedDialog(false);
  }

  function handleSelectCollection(id: CollectionName) {
    dispatch(photoModule.actions.setActiveCollection(id));
  }

  function handleShowCollectionsManager() {
    setShowCollectionsManagerDialog(true);
  }

  function handleClose(closeAll?: boolean) {
    setDisplayCollection('');

    if (!!closeAll) {
      setShowCollectionsManagerDialog(false);
    }
  }

  return (
    <React.Fragment>
      <div className="collections_menu_container">
        {!isLoggedIn ? (
          <SignInSSO
            text="Sign in to create Image Collection"
            className="menu-trigger button themed"
          />
        ) : (
          <CollectionsMenu
            onSelectCollection={handleSelectCollection}
            onSaveUncollected={handleSaveUncollected}
            onShowCollectionsManager={handleShowCollectionsManager}
            activeCollection={activeCollection}
            collections={collections}
            uncollected={uncollected}
          />
        )}
      </div>

      {showUncollectedDialog &&
        renderModal(
          <SaveUncollectedModal
            onCancel={handleCancelSaveUncollected}
            lastFocusedElementId="collections-menu-trigger"
          />
        )}

      {showCollectionsManagerDialog &&
        showSingleCollectionManager &&
        renderModal(
          <SingleCollectionManager onClose={handleClose} displayCollection={displayCollection} />
        )}

      {showCollectionsManagerDialog &&
        !showSingleCollectionManager &&
        renderModal(
          <SelectCollectionModal
            setDisplayCollection={setDisplayCollection}
            onClose={() => handleClose(true)}
          />
        )}
    </React.Fragment>
  );
}

export default ImageCollectionsController;
